import { render, staticRenderFns } from "./Quick.vue?vue&type=template&id=6b3925b4&"
import script from "./Quick.vue?vue&type=script&lang=ts&"
export * from "./Quick.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports